// extracted by mini-css-extract-plugin
export default {"no-pointer":"index-module__no-pointer___wuxEb","noPointer":"index-module__no-pointer___wuxEb"};